import config from 'services/config'

export const getImgUrlFromCDN = (fileName, mediaTag, hotelId) => {
  const mediaTagRegex = new RegExp(`^c/|a/`)
  const cleanFileName = fileName.replace(mediaTagRegex, '')

  return `${config.inviteMediaBaseUrl}/${hotelId}/${mediaTag}/${cleanFileName}`
}
